module.exports = __webpack_public_path__ + "static/img/12.66ddb1a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/3/sp/12.png
// module id = CZf0
// module chunks = 0